if (!customElements.get('surprise-product')) {
  class SurpriseProduct extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setupRerollButtons();
    }

    setupRerollButtons() {
      const rerollButtons = this.querySelectorAll('button[data-reroll]');
      rerollButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.showRandomProduct();
        });
      });
    }

    showRandomProduct() {
      const products = this.querySelectorAll('[surprise-product-markup]');
      const confetti = document.querySelector('[surprise-confetti]');
      const buttons = document.querySelectorAll('.surprise-product__actions .btn');
      
      if (products.length === 0) return;

      // Disable reroll buttons while cycling
      buttons.forEach(button => button.setAttribute('disabled', true));

      // Hide confetti while cycling
      if (confetti) {
        confetti.classList.add('hidden');
        confetti.classList.remove('animate-zoom-in');
      }

      // Hide all products initially and remove animation
      products.forEach(product => {
        product.classList.add('hidden');
        product.classList.remove('animate-zoom-in');
      });

      let currentIndex = 0;
      let cycleCount = 0;
      const totalCycles = 10;
      const cycleInterval = 200; // 0.2s in milliseconds

      const cycle = () => {
        // Hide all products
        products.forEach(product => product.classList.add('hidden'));
        
        // Show current product
        products[currentIndex].classList.remove('hidden');
        
        // Move to next product
        currentIndex = (currentIndex + 1) % products.length;
        cycleCount++;

        // Stop after 10 cycles and select a random product
        if (cycleCount >= totalCycles) {
          clearInterval(intervalId);
          
          // Select a random product to display
          const randomIndex = Math.floor(Math.random() * products.length);
          products.forEach(product => product.classList.add('hidden'));
          products[randomIndex].classList.remove('hidden');
          products[randomIndex].classList.add('animate-zoom-in');
          
          // Show confetti when cycle stops
          if (confetti) {
            confetti.classList.remove('hidden');
            confetti.classList.add('animate-zoom-in');
          }

          // Re-enable reroll buttons
          buttons.forEach(button => button.removeAttribute('disabled'));
        }
      };

      // Start cycling
      const intervalId = setInterval(cycle, cycleInterval);
      
      // Show first product immediately
      products[0].classList.remove('hidden');
    }
  }
  customElements.define('surprise-product', SurpriseProduct);
}